import { Box, CircularProgress } from '@mui/material';

/**
 * Covers the entirely of its parent. Requires the parent to be relatively positioned.
 */
export const LoadingOverlay = ({ size = '4rem' }: { size?: string }) => (
    <Box
        sx={{
            opacity: '35%',
            background: '#212121',
            inset: 0,
            width: '100%',
            height: '100%',
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 3,
        }}>
        <CircularProgress sx={{ color: 'white' }} size={size} />
    </Box>
);
